import { render, staticRenderFns } from "./AddFieldsFromBrowser.vue?vue&type=template&id=6bbda93e&scoped=true"
import script from "./AddFieldsFromBrowser.vue?vue&type=script&lang=js"
export * from "./AddFieldsFromBrowser.vue?vue&type=script&lang=js"
import style0 from "./AddFieldsFromBrowser.vue?vue&type=style&index=0&id=6bbda93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbda93e",
  null
  
)

export default component.exports